import React, { useCallback, useState, useEffect } from "react";
import { observer } from "mobx-react";
import DOMPurify from "dompurify";
import IconButton from "../../../../../elements/button/IconButton.jsx";
import {
  Title,
  ContainerInnerTab,
  SignatureHeader,
  BorderedIconButton,
  ErrorMessageSignature,
  TextAreaContainer,
} from "../../PlaygroundView.styled.js";
import TextArea from "../../../../../elements/v2/TextArea/TextArea.jsx";
import HtmlPreviewModal from "../../../../../elements/v2/modals/HtmlPreviewModal";
import useStore from "../../../../../hooks/useStore.js";
import {
  ChooseModelContainer,
  Description,
  Label,
} from "./AdvancedConfigurationTab.styled.js";
import SelectDropdown from "../../../../../elements/v2/SelectDropdown/SelectDropdown.jsx";
import { API } from "aws-amplify";
// [DEPRECATED_GRAPHQL] - Para eliminación: getLLMModels usa GraphQL query
// TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente

// import { getLLMModels } from "../../../../../graphql/queries";
import { useUserCheckPermissions } from "../../../../../hooks/useUserCheckPermissions";
import { PermissionCodes, PermissionLevels } from "../../../../../utils/enums";

const AdvancedConfigurationTab = observer(() => {
  const { editAgent } = useStore();
  const [hasError, setHasError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sanitizedHtml, setSanitizedHtml] = useState("");
  const [llmModels, setLLMModels] = useState({});
  const { checkPermission } = useUserCheckPermissions();

  // [DEPRECATED_GRAPHQL] - Para eliminación: fetchLLMModels usa GraphQL query getLLMModels
  // TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
  
  // useEffect(() => {
  //   const fetchLLMModels = async () => {
  //     try {
  //       const response = await API.graphql({
  //         query: getLLMModels,
  //         authMode: "AMAZON_COGNITO_USER_POOLS",
  //       });
  //       const models = JSON.parse(response.data.getLLMModels.body);
  //       setLLMModels(models);
  //     } catch (error) {
  //       console.error("Error fetching LLM models:", error);
  //     }
  //   };

  //   fetchLLMModels();
  // }, []);

  const handleModelSelect = (model) => {
    editAgent.setLlmModelSelected(model);
  };

  const handleHtmlChange = useCallback((e) => {
    const value = e.target.value;
    editAgent.onChangeSignature(value);

    const parser = new DOMParser();
    const doc = parser.parseFromString(value, "text/html");
    const containsHtml = doc.body.childElementCount > 0;

    setHasError(value && !containsHtml);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closePreview = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  useEffect(() => {
    const sanitized = DOMPurify.sanitize(editAgent.signature);
    setSanitizedHtml(sanitized);
  }, [editAgent.signature]);

  return (
    <ContainerInnerTab>
      {checkPermission(PermissionCodes.ADVANCED_LLM, PermissionLevels.VIEW) && (
      <ChooseModelContainer>
        <div>
          <Label>Choose Model</Label>
          <Description>
            Select the LLM powers your agent's reasoning, decision making and
            text generation
          </Description>
        </div>
        <div>
          <SelectDropdown
            itemsContainerWidth="363px"
            itemsContainerHeight="488px"
            label="Choose Model"
            enableSearch={true}
            items={llmModels || {}}
            onSelect={handleModelSelect}
            selectedItem={editAgent.llmModelSelected}
            defaultValue={editAgent.model || null}
            width="100%"
          />
        </div>
      </ChooseModelContainer>
      )}
      {checkPermission(PermissionCodes.ADVANCED_SIGNATURE, PermissionLevels.VIEW) && (
      <span>
        <SignatureHeader>
          <Title>Signature</Title>
          {!hasError && editAgent.signature.trim() && (
            <BorderedIconButton>
              <IconButton
                icon="visibility"
                width="24px"
                height="24px"
                onClick={() => setIsModalOpen(true)}
              />
            </BorderedIconButton>
          )}
        </SignatureHeader>
        <TextAreaContainer>
          <TextArea
            height="160px"
            resize="none"
            placeholder="Enter HTML Signature"
            value={editAgent.signature}
            onChange={handleHtmlChange}
            displayError={hasError}
          />
          {hasError && (
            <ErrorMessageSignature>
              This field only supports HTML code, please check the format and
              try again.
            </ErrorMessageSignature>
          )}
        </TextAreaContainer>
      </span>
     )}
      <HtmlPreviewModal
        isOpen={isModalOpen}
        onClose={closePreview}
        dataTestId="html-preview-modal"
      >
        <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
      </HtmlPreviewModal>
    </ContainerInnerTab>
  );
});

export default AdvancedConfigurationTab;
